import { adrStore } from '../adrStore';
import { createStoreDispatcher, type StoreDispatcher } from '../../commands/storeDispatcher';
import type { AdrCommand } from './adrCommands';

let dispatcher: StoreDispatcher<AdrCommand> | null = null;
let initialized = false;

export function initAdrDispatcher(): StoreDispatcher<AdrCommand> {
  if (initialized) return dispatcher!;
  initialized = true;
  dispatcher = createStoreDispatcher<AdrCommand>(adrStore);
  return dispatcher;
}

export function getAdrDispatcher(): StoreDispatcher<AdrCommand> {
  if (!dispatcher) {
    throw new Error('ADR dispatcher not initialized. Call initAdrDispatcher() first.');
  }
  return dispatcher;
}
